import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const FiveNav = () => import('@/views/FiveNav')
const Realize = () => import('@/components/realize/index.vue')
const combination = () => import('@/views/combination')
const combinationFirst = () => import('@/components/combination/combinationFirst.vue')
const combinationTwo = () => import('@/components/combination/combinationTwo.vue')
const Plan = () => import('@/views/plan')
const rad = () => import('@/components/plan/rad')
const detection  = () => import('@/components/plan/detection')
const system  = () => import('@/components/plan/system')
const talent  = () => import('@/components/plan/talent')
const News = () => import('@/components/news/news.vue')
const News1 = () => import('@/views/News')
const NewsDetails1 = () => import('@/components/news/news1.vue')
const NewsDetails2 = () => import('@/components/news/news2.vue')
const NewsDetails3 = () => import('@/components/news/news3.vue')
const NewsDetails4 = () => import('@/components/news/news4.vue')
const Achievement = () => import('@/components/achievement/achievement.vue')
const Expand = () => import('@/components/expand/expand.vue')
const Knowledge = () => import('@/views/knowledge.vue')
const Knowledge1 = () => import('@/components/knowledge/knowledge1.vue')
const Knowledge2 = () => import('@/components/knowledge/knowledge2.vue')
const Knowledge3 = () => import('@/components/knowledge/knowledge3.vue')
const Green = () => import('@/components/green/green.vue')
const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/fivenav',
    component:FiveNav,
    children:[
      {
        path:'1',
        component:Realize
      },
      {
        path:'2',
        component:Realize
      },
      {
        path:'3',
        component:Realize
      },
    ]
  },
  {
    path:'/news/news',
    component:News
  },
  {
    path:'/news',
    component:News1,
    children:[
      {
        path:'1',
        component:NewsDetails1
      },
      {
        path:'2',
        component:NewsDetails2
      },
      {
        path:'3',
        component:NewsDetails3
      },
      {
        path:'4',
        component:NewsDetails4
      },
    ]
  },
  {
    path:'/combination',
    component:combination,
    children:[
      {
        path:'1',
        component:combinationFirst
      },
      {
        path:'2',
        component:combinationTwo
      },
    ]
  },
  {
    path:'/plan',
    component:Plan,
    children:[
      {
        path:'1',
        component:rad
      },
      {
        path:'2',
        component:detection
      },
      {
        path:'3',
        component:system
      },
      {
        path:'4',
        component:talent
      }
    ]
  },
  {
    path: '/achievement',
    component:Achievement
  },
  {
    path: '/expand',
    component:Expand
  },
  {
    path:'/knowledge',
    component:Knowledge,
    children:[
      {
        path:'1',
        component:Knowledge1
      },
      {
        path:'2',
        component:Knowledge2
      },
      {
        path:'3',
        component:Knowledge3
      },
    ]
  },
  {
    path: '/green',
    component:Green
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router